<template>
  <div class="bbe-email-header">
    <transition name="bbe-fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <img class="bbe-email-header__avatar" :src="activeEmail.userImage || defaultAvatar"/>
    <div class="bbe-email-header-user">
      <transition-group class="bbe-email-header-user-mail-info" tag="div" :name="displayTags ? 'bbe-flip-tags' : ''">
        <span class="bbe-email-header-user-mail-info__name" :key="'nameMail'">
          {{ activeEmail.from ? activeEmail.from.name : '' }}
        </span>
        <div class="bbe-email-header-user-mail-info-tag"
             v-for="tag in activeEmail.tags"
             :key="tag.id">
          <span>#{{ tag.name }}</span>
          <i class="email-icon-close bbe-email-header-user-mail-info-tag__cross" @click="removeTag(tag)"/>
        </div>
        <div class="bbe-email-header-user-mail-info-new-hashtag"
             :key="'addNewTag'"
             v-click-outside="closeSelectTag"
             @click="openSelectTag = !openSelectTag">
            <span class="bbe-email-header-user-mail-info-new-hashtag__placeholder"
                  v-if="!activeEmail.tags || !activeEmail.tags.length">
              Add hashtag
            </span>
          <i class="email-icon-plus bbe-email-header-user-mail-info-new-hashtag__add"
             :class="{'bbe-email-header-user-mail-info-new-hashtag__add_open': openSelectTag}"/>
          <transition name="bbe-fade-options">
            <SelectTags class="bbe-email-header-user-mail-info-new-hashtag__select"
                        :thread="activeEmail"
                        @close="closeSelectTag"
                        v-if="openSelectTag"/>
          </transition>
        </div>
      </transition-group>
      <div class="bbe-email-header-user__email">
        <span class="bbe-email-header-user__prefix">From:</span>
        {{ activeTab === 'SENT' && isSentMail ? gmailUser : emailFrom }}
      </div>
      <div class="bbe-email-header-user__email">
        <span class="bbe-email-header-user__prefix">To:</span>
        {{ activeTab === 'SENT' && isSentMail ? emailFrom : gmailUser }}
        <div class="bbe-email-header-user-more-info"
             ref="popupMailInfo"
             v-click-outside="hideMailInfo"
             @click="showMailInfo = !showMailInfo">
          <i class="email-icon-arrow-mail-info bbe-email-header-user-more-info__icon"/>
          <transition name="bbe-bounce">
            <div class="bbe-email-header-user-more-info-popup"
                 :style="{
                   maxWidth: popupMailInfoWidth + 'px',
                   userSelect: !!popupMailInfoWidth
                 }"
                 v-if="showMailInfo"
                 @click.stop>
              <div class="bbe-email-header-user__email bbe-email-header-user__email_popup">
                <span class="bbe-email-header-user__prefix">From:</span>
                <span class="bbe-email-header-user__content">
                  {{ activeEmail.from ? activeEmail.from.email : '' }}
                </span>
              </div>
              <div class="bbe-email-header-user__email bbe-email-header-user__email_popup">
                <span class="bbe-email-header-user__prefix">To:</span>
                <span class="bbe-email-header-user__content">
                  {{ emailTo }}
                </span>
              </div>
              <div class="bbe-email-header-user__email bbe-email-header-user__email_copy"
                   :class="'bbe-email-header-user__email_popup'"
                   v-if="activeEmail.cc">
                <span class="bbe-email-header-user__prefix">Cc:</span>
                <span class="bbe-email-header-user__content">
                  {{ activeEmail.cc }}
                </span>
              </div>
              <div class="bbe-email-header-user__email bbe-email-header-user__email_copy"
                   :class="'bbe-email-header-user__email_popup'"
                   v-if="activeEmail.bcc">
                <span class="bbe-email-header-user__prefix">Bcc:</span>
                <span class="bbe-email-header-user__content">
                  {{ activeEmail.bcc }}
                </span>
              </div>
              <div class="bbe-email-header-user__email bbe-email-header-user__email_copy"
                   :class="'bbe-email-header-user__email_popup'"
                   v-if="activeEmail.subject">
                <span class="bbe-email-header-user__prefix">Subject:</span>
                <span class="bbe-email-header-user__content bbe-email-header-user__content_text">
                  {{ activeEmail.subject }}
                </span>
              </div>
              <div class="bbe-email-header-user__email bbe-email-header-user__email_copy"
                   :class="'bbe-email-header-user__email_popup'"
                   v-if="activeEmail.date">
                <span class="bbe-email-header-user__prefix">Date:</span>
                <span class="bbe-email-header-user__content bbe-email-header-user__content_text">
                  {{ mailDate }}
                </span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="bbe-email-header-options">
      <div class="bbe-email-header-options__item"
           :class="{'bbe-email-header-options__item_active': option.isActive}"
           v-for="option in optionsIcons"
           :key="option.icon"
           @click="clickOption(option)"
           @mouseenter="option.hover = true"
           @mouseleave="option.hover = false">
        <i :class="[
           'email-icon-' + (option.hover || option.isActive ? option.iconActive : option.icon),
           {
             'bbe-email-header-options__icon_garbage': option.icon === 'garbage',
             'bbe-email-header-options__icon_perspective': option.icon === 'perspective'
           }
           ]"
           class="bbe-email-header-options__icon"/>
        <transition name="bbe-bounce">
          <div class="bbe-email-header-options__tooltip" v-if="option.hover">
            {{ option.tooltip }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import defaultAvatar from '@/assets/images/user.png'
import {cloneDeep, find, get, set, filter, findIndex} from 'lodash'
import {sidebarTabs} from '@/constants/sidebarTabs'
import SelectTags from '@/components/Main/SelectTags/SelectTags'
import userEmailsApi from '@/api/UserEmails/api'
import GmailApi from '@/api/Gmail/api'
import moment from 'moment'
import headerGmail from '@/mixin/headerGmail'
import getInfoFromThread from '@/mixin/getInfoFromThread'

export default {
  name: 'EmailHeader',
  components: {
    LoaderFly,
    SelectTags
  },
  mixins: [
    headerGmail,
    getInfoFromThread
  ],
  data () {
    return {
      optionsIcons: [
        {
          icon: 'share',
          iconActive: 'share-active',
          hover: false,
          type: 'reply',
          tooltip: 'Reply'
        },
        {
          icon: 'next',
          iconActive: 'next-active',
          hover: false,
          type: 'forward',
          tooltip: 'Forward'
        },
        {
          icon: 'tab-todo',
          iconActive: 'tab-todo',
          hover: false,
          isActive: false,
          type: 'SAVED',
          tooltip: 'Need to do',
          label: this.getLabelId('SAVED')
        },
        {
          icon: 'perspective',
          iconActive: 'perspective',
          hover: false,
          isActive: false,
          type: 'TODO',
          tooltip: 'Need to control',
          label: this.getLabelId('TODO')
        },
        {
          icon: 'garbage',
          iconActive: 'garbage-active',
          hover: false,
          type: 'delete',
          tooltip: 'Delete'
        }
      ],
      defaultAvatar: defaultAvatar,
      loaderRun: false,
      openSelectTag: false,
      displayTags: true,
      showMailInfo: false,
      popupMailInfoWidth: 0
    }
  },
  computed: {
    activeTab () {
      return this.$store.getters.activeTab
    },
    activeEmail: {
      get: function () {
        return this.$store.getters.activeEmail
      },
      set: function (data) {
        this.$store.dispatch('setActiveEmail', data)
      }
    },
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    },
    gmailUser () {
      return get(this.activeUser, 'gmail.email', '')
    },
    isSentMail () {
      const tags = get(this.activeEmail, 'tags', [])
      return tags.includes('SENT')
    },
    emailTo () {
      const emailsCc = get(this.activeEmail, 'cc', '')
      const firstCcAddress = get(emailsCc.split(','), 0, '')
      const emailTo = get(this.activeEmail, 'to.email', '')
      return emailTo || firstCcAddress
    },
    emailFrom () {
      return get(this.activeEmail, 'from.email', '')
    },
    mailDate () {
      const date = moment(get(this.activeEmail, 'date', ''))
      const isValidDate = date.isValid()
      return isValidDate ? date.format('MMM DD, YYYY, hh:mm A') : ''
    }
  },
  methods: {
    calcPopupMailInfoWidth () {
      const popup = this.$refs.popupMailInfo
      if (!popup) return 0
      const position = popup.getBoundingClientRect()
      const windowWidth = document.documentElement.clientWidth
      this.popupMailInfoWidth = windowWidth - position.left - 50
      if (window.getSelection) window.getSelection().removeAllRanges()
    },
    hideMailInfo () {
      this.showMailInfo = false
      this.popupMailInfoWidth = 0
    },
    removeTag (tag) {
      const tags = get(this.activeEmail, 'tags', [])
      const tagIndex = findIndex(tags, {id: tag.id})
      if (tagIndex !== -1) tags.splice(tagIndex, 1)
      const threadId = get(this.activeEmail, 'id', '')
      const userMailId = get(this.activeEmail, 'idUserMail', '')
      if (!threadId || !userMailId) return
      const body = {
        id: userMailId,
        tags: tags.map(tag => tag.id),
        googleId: threadId
      }
      userEmailsApi.updateUserEmails(body)
    },
    closeSelectTag () {
      this.openSelectTag = false
    },
    getLabelId (type) {
      const label = find(sidebarTabs, {systemId: type})
      return get(label, 'id', '')
    },
    clickOption (option) {
      if (option.type === 'reply') {
        this.$emit('reply')
      } else if (option.type === 'forward') {
        this.$emit('forward')
      } else if (option.type === 'delete') {
        const newEmail = cloneDeep(this.activeEmail)
        newEmail.delete = true
        this.activeEmail = newEmail
      } else if (option.type === 'SAVED' || option.type === 'TODO') {
        this.setLabel(option)
      }
    },
    setLabel (option) {
      return
      const labelId = this.getLabelId(option.type)
      const messageId = get(this.activeEmail, 'id', '')
      if (!labelId || !messageId) return
      const body = {addLabelIds: [], removeLabelIds: []}
      const arrayName = option.isActive ? 'removeLabelIds' : 'addLabelIds'
      body[arrayName].push(labelId)
      this.loaderRun = true
      this.$gapi.request({
        path: `https://www.googleapis.com/gmail/v1/users/me/threads/${messageId}/modify`,
        method: 'POST',
        body: body
      })
        .then(resp => {
          const messages = get(resp, 'result.messages', [])
          const labels = messages.reduce((acc, msg) => {
            acc = acc.concat(msg.labelIds)
            return acc
          }, [])
          set(this.activeEmail, 'labelIds', labels)
          this.checkLabelActive()
          this.loaderRun = false
        })
        .catch(err => {
          console.error(err)
          this.loaderRun = false
        })
    },
    checkLabelActive () {
      const optionsWithLabels = filter(this.optionsIcons, icon => icon.label)
      const labelIds = get(this.activeEmail, 'labelIds', [])
      optionsWithLabels.forEach(item => {
        item.isActive = labelIds.includes(item.label)
      })
    }
  },
  watch: {
    showMailInfo (newVal) {
      if (newVal) this.$nextTick(this.calcPopupMailInfoWidth)
    },
    activeEmail (newVal, oldVal) {
      if (newVal === oldVal) return
      this.checkLabelActive()
      this.displayTags = false
      setTimeout(() => {
        this.displayTags = true
      }, 550)
      this.hideMailInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-email-header {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 30px 0;
  margin: 0 30px;
  border-bottom: 1px solid $color-wild-sand;

  &__avatar {
    margin-right: 21px;
    width: 53px;
    height: 53px;
    object-fit: contain;
    border-radius: 50%;
  }

  &-user {

    &-more-info {
      position: relative;
      display: inline-block;
      padding: 2px;
      margin: -2px -2px -2px 0;
      cursor: pointer;
      transition: 0.3s;
      border-radius: 2px;
      background-color: transparent;

      &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 14px;
        width: 14px;
        font-size: 10px;
        color: $color-silver-chalice;
        transition: 0.3s;
      }

      &:hover &__icon {
        color: $color-dusty-gray;
      }

      &:hover {
        background-color: $color-alabaster;
      }

      &-popup {
        position: absolute;
        min-width: 200px;
        width: 100vw;
        padding: 12px;
        background: $color-white;
        box-shadow: 0 0 15px rgba($color-accent, 0.12);
        border-radius: 4px;
        z-index: 99;
        cursor: default;
        transition: 0.3s;
      }
    }

    &-mail-info {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: flex-start;
      margin-bottom: 6px;

      &__name {
        margin-right: 12px;
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 22px;
      }

      &-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        margin-bottom: 8px;
        padding: 4px;
        background-color: $color-link-water;
        border-radius: 4px;
        color: $color-accent;
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        white-space: nowrap;
        cursor: default;

        &__cross {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 3px;
          margin-right: -3px;
          font-size: 8px;
          transition: 0.3s;
          cursor: pointer;
          opacity: 0.5;

          &:hover {
            opacity: 1;
          }
        }
      }

      &-new-hashtag {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $color-accent;
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          color: $color-accent-hover;
        }

        &__add {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          height: 22px;
          width: 22px;
          transition: 0.3s;

          &_open {
            transform: rotate(45deg);
          }
        }

        &__select {
          position: absolute;
          top: 32px;
          right: 0;
          z-index: 10;
        }

        &__placeholder {
          font-weight: 500;
          font-size: 13px;
          line-height: 16px;
        }
      }
    }

    &__prefix {
      color: $color-dusty-gray;
      user-select: none;
    }

    &__content {
      margin-left: 6px;
      word-break: break-all;

      &_text {
        color: $color-black
      }
    }

    &__email {
      color: $color-accent;
      font-size: 12px;
      margin-bottom: 6px;

      &_popup {
        display: flex;
        margin-bottom: 8px;
      }
    }

    &__subject {
      color: $color-silver-chalice;
      word-break: break-word;
      white-space: pre-wrap;
      max-width: 100%;
      font-style: normal;
      font-size: 12px;
    }
  }

  &-options {
    display: flex;
    justify-content: center;
    height: 41px;
    box-shadow: 0 0 15px rgba($color-accent, 0.12);
    border-radius: 59px;
    margin: 0 0 0 auto;

    &__icon {
      color: $color-silver-chalice;
      font-size: 16px;

      &_perspective {
        font-size: 20px;
      }
    }

    &__tooltip {
      position: absolute;
      bottom: -31px;
      color: $color-white;
      font-weight: 500;
      font-size: 11px;
      padding: 4px 5px;
      background: rgba($color-black, 0.59);
      border-radius: 3px;
      z-index: 3;
      pointer-events: none;
      user-select: none;
      white-space: nowrap;
    }

    &__item {
      position: relative;
      width: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: $color-white;
      border: 1px solid transparent;
      transition: .3s;
      cursor: pointer;
      border-right: 1px solid $color-gallery;

      &:hover {
        background-color: $color-gallery;
        border: 1px solid $color-gallery;
      }

      &_active,
      &:hover {
        .bbe-email-header-options__icon {
          color: $color-accent;
        }

        .bbe-email-header-options__icon_garbage {
          color: $color-pomegranate;
        }
      }

      &:first-child {
        border-radius: 59px 0 0 59px;
      }

      &:last-child {
        border-radius: 0 59px 59px 0;
        border-right: none;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Email/EmailHeader/EmailHeader.vue